import React, {Component} from "react";
import {Link} from "react-router";

class PricePlaceholder extends Component {
    render() {
        return (
            <div className="block app-price-plans" id="pricing">
                <div className="container text-center">
                    <div className="row m-b-md">
                        <div className="col-sm-8 col-sm-offset-2 col-lg-6 col-lg-offset-3">
                            <h6 className="text-muted text-uppercase">Business Talk</h6>
                            <h3 className="m-t-0">Starts from free.</h3>

                            <div className="p-x">
                                <p>From startup to global enterprise. <br className="visible-sm"/>We've
                                    got you covered.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row m-b-lg">
                        <Link to="/docs" className="btn btn-lg btn-primary m-t-sm-c-xs m-t-sm-c-sm m-r-sm">
                            Get Started
                        </Link>
                        <Link to="/pricing" className="btn btn-lg btn-primary-outline btn-lg m-t-sm-c-xs m-t-sm-c-sm">
                            See Pricing
                        </Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default PricePlaceholder;



// WEBPACK FOOTER //
// ./src/modules/views/common/PricePlaceholder.js